/**
 * 竖式题
 */
import QuestionVertical from './view';
import './index.less';

export default QuestionVertical;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/vertical/index.js